import type { ImageGalleryComponent as ImageGalleryComponentType } from '../../schemas/validation';
import type { GalleryColors } from './types';

interface ThemeStyles {
  imageGallery?: {
    background?: string;
    text?: string;
    title?: string;
    subtitle?: string;
    caption?: string;
    filterButton?: string;
    filterButtonActive?: string;
  };
}

export function useImageGalleryColors(
  data: ImageGalleryComponentType['data'],
  themeStyles: ThemeStyles
): GalleryColors {
  // Color priority: component.data.customColors > component.data colors > theme colors > fallback
  const backgroundColor =
    data.customColors?.background || themeStyles.imageGallery?.background || '#ffffff';
  const textColor = data.customColors?.text || themeStyles.imageGallery?.text || '#111827';
  const titleColor = data.customColors?.title || themeStyles.imageGallery?.title || '#111827';
  const subtitleColor =
    data.customColors?.subtitle || themeStyles.imageGallery?.subtitle || '#6b7280';
  const captionColor = data.customColors?.caption || themeStyles.imageGallery?.caption || '#4b5563';
  const filterButtonColor =
    data.customColors?.filterButton || themeStyles.imageGallery?.filterButton || '#e5e7eb';
  const filterButtonActiveColor =
    data.customColors?.filterButtonActive ||
    themeStyles.imageGallery?.filterButtonActive ||
    '#3b82f6';

  return {
    backgroundColor,
    textColor,
    titleColor,
    subtitleColor,
    captionColor,
    filterButtonColor,
    filterButtonActiveColor,
  };
}

export function getBackgroundStyle(backgroundColor: string): React.CSSProperties {
  const isGradient = backgroundColor.includes('gradient');
  const backgroundStyle: React.CSSProperties = {};

  if (isGradient) {
    backgroundStyle.background = backgroundColor;
  } else {
    backgroundStyle.backgroundColor = backgroundColor;
  }

  return backgroundStyle;
}
